  
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./modules/auth";
import data from "./modules/data";

// Create store
export default new Vuex.Store({
  modules: {
    auth,
    data
  },
  plugins: [createPersistedState()],
});
